import { Grid } from '@mui/material';
import React from 'react';
import SliderPage from './Home/SliderPage';
import FeaturedGames from './Home/FeaturedGames';
import NavBar from './NavBar/NavBar';
import CrossChainPlateForm from './Home/CrossChainPlateForm';
import HowItWork from './Home/HowItWork';
import { BackedBy } from './Home/BackedBy';
import UpcommingProject from './Home/UpcommingProject';
import Footer from './Home/Footer';
import FooterPage from '../Screen/FooterPage';
const Home = () => {

  return (
    <Grid container>
      <Grid item md={2} lg={2} xl={2}>
        <NavBar />
      </Grid>
      <Grid item md={10} lg={10} xl={10}>
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <SliderPage />
            </Grid> 
            <Grid item md={12} lg={12} xl={12}>
      <HowItWork />
      </Grid>
      <Grid item md={12} lg={12} xl={12}>
      <CrossChainPlateForm />
      </Grid>
      <Grid item md={12} lg={12} xl={12}>
      <FeaturedGames />
      </Grid>
      <Grid item md={12} lg={12} xl={12}>
      <UpcommingProject />
      </Grid>
        </Grid>
      </Grid>
      
      
      
     
      <Grid item md={12} lg={12} xl={12} sx={{
          background:
            "linear-gradient(to top, rgb(0, 0, 0) 0%, rgb(20, 22, 38) 100%)",
          paddingLeft: "10%",paddingRight: "10%",
        }}>
        <Grid container>
          <Grid item md={2} lg={2} xl={2}>
          </Grid>
          <Grid item md={10} lg={10} xl={10}>
          <BackedBy />
          </Grid>
        </Grid>
      </Grid>
      <Grid item md={12} lg={12} xl={12} sx={{
          backgroundColor:'black',
          paddingLeft: "10%",paddingRight: "10%",
        }}>
        <Grid container>
          <Grid item md={2} lg={2} xl={2}>
          </Grid>
          <Grid item md={10} lg={10} xl={10}>
          <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Footer />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{backgroundColor:'black'}}>
          <FooterPage />
            </Grid>  
            </Grid>
          
          </Grid>
        </Grid>
      
      </Grid>
    </Grid>
  );
};

export default Home;